<template>
  <div v-if="data !== null">
    <Top />
    <div class="container">
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-6">
          <Pagination :numberOfDots="5" :numberOfVisitedDots="2" />
          <div class="clearfix"></div>
          <div class="header-wrapper">
            <p class="text-primary-fh" v-html="data.screening.veganHeader"></p>
          </div>
          <div class="clearfix"></div>
          <p v-html="data.screening.veganText"></p>
          <div class="clearfix"></div>
        </div>
        <div class="col-sm"></div>
      </div>
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-6">
          <div class="clearfix"></div>
          <button
          class="btn btn-primary btn-lg btn-block"
          @click="verifyVeganDiet('Ja')"
          :class="previousanswer === 'Ja' ? 'previous-answer': ''">Ja</button>
          <div class="clearfix"></div>
          <button
          class="btn btn-primary btn-lg btn-block"
          @click="verifyVeganDiet('Nej')"
          :class="previousanswer === 'Nej' ? 'previous-answer': ''">Nej</button>
          <div class="clearfix"></div>
          <button class="btn btn-outline-dark btn-lg btn-block" @click="$router.go(-1)">&#8592; Tillbaka</button>
          <div class="clearfix"></div>
          <small class="pull-left">Välj ett alternativ för att gå vidare.</small>
        </div>
        <div class="col-sm"></div>
      </div>
    </div>
    <Bottom />
  </div>
</template>

<script>
import Top from '../../src/components/Top'
import Bottom from '../../src/components/Bottom'
import Pagination from '../../src/components/Pagination'
import config from '../../config/index.js'
import axios from '../plugins/axios'
import FieldId from '../plugins/fieldId'
import { request } from '../plugins/datocms'

export default {
  name: 'screeningvegandiet',
  components: {
    Top,
    Bottom,
    Pagination
  },
  data () {
    return {
      data: null,
      previousanswer: ''
    }
  },
  methods: {
    verifyVeganDiet (_answer) {
      if (_answer !== null) {
        let loader = this.$loading.show()
        const fieldId = FieldId('screeningvegan')
        const answer = {
          question: 'Äter du rent vegansk kost?',
          answer: _answer,
          timestamp: new Date().toLocaleString('sv-SE', { timeZone: 'CET' })
        }
        axios.postScreeningAnswer(config.screeningAnswerUri, JSON.stringify(answer), fieldId).then((response) => {
          if (response.status === 200) {
            loader.hide()
            this.$router.push('screeningdiet')
          }
        }, (error) => {
          if (error.response && error.response.status === 401) {
            loader.hide()
            window.location.href = window.location.origin.concat('/error')
          } else {
            loader.hide()
            console.log(error)
          }
        })
      }
    }
  },
  beforeMount () {
    let loader = this.$loading.show()
    axios._get(config.screeningAnswerUri).then(response => {
      const result = response.data.answers.find(answ => answ.fieldId === 8963171)
      if (result && result.length !== 0) {
        const parsedResult = JSON.parse(result.answer)
        this.previousanswer = parsedResult.answer
        loader.hide()
      } else {
        this.previousanswer = ''
        loader.hide()
      }
    }).catch((error) => {
      if (error.response && error.response.status === 401) {
        loader.hide()
        window.location.href = window.location.origin.concat('/error')
      } else {
        console.log('Request went bad to screeninganswers: ' + error)
        loader.hide()
      }
    })
  },
  async mounted () {
    this.data = await request({
      query: `
        {
          screening {
            veganHeader
            veganText
          }
        }
      `
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  margin-top: 110px;
  margin-bottom: 50px;
  min-height: 60vh;
}
@media screen and (min-width: 800px) {
  .header-wrapper {
    display: flex;
  }
}
.pull-left {
  float: left !important;
}
</style>



// WEBPACK FOOTER //
// src/components/ScreeningVeganDiet.vue